import { Money } from '../../atoms'
import { DELIVERY_TYPES, DELIVERY_TYPE_ENUM } from '../../../common/constants'
import { useAppSelector } from '../../../common/hooks'

import {
  StyledAlert,
  StyledParagraph,
  StyledPriceContainer,
  StyledTag,
  StyledTitle,
  StyledToggleButton,
  StyledToggleButtonGroup,
  StyledType,
} from './styles/ShippingTypes.style'
import { getShippingInfos } from '../../../common/utils'
import { getMissionsDiscount, getSelectedMissionMinOrderAmount } from '../../../common/missions'
import TwoDaysTag from '../../atoms/TwoDaysTag'

export const ShippingTypesSelector = () => {
  const { cart } = useAppSelector((state) => state)
  const [deliveryType, missions] = useAppSelector((state) => [
    state.shippingInfos.shippingType,
    state.missions,
  ])

  const fee = getShippingInfos(deliveryType).value
  const discountAmount = getMissionsDiscount(missions, cart, fee)
  const selectedMission = getSelectedMissionMinOrderAmount(missions)

  return (
    <StyledToggleButtonGroup value={deliveryType} exclusive data-testid="toggle-group">
      <StyledToggleButton
        value={DELIVERY_TYPE_ENUM.twoDays}
        disabled={true}
        data-testid="shipping-type"
      >
        <StyledType>
          <StyledTitle>
            <StyledTag>
              Entrega em <TwoDaysTag openTooltip={false} />
            </StyledTag>
            <StyledPriceContainer>
              {discountAmount ? (
                <h6 className="free-shipping">Grátis</h6>
              ) : (
                <Money
                  amount={DELIVERY_TYPES.twoDays.value}
                  isBold={deliveryType === DELIVERY_TYPE_ENUM.twoDays}
                />
              )}
            </StyledPriceContainer>
          </StyledTitle>
          <div className="days-to-delivery">
            <StyledParagraph>
              Seu pedido será entregue em até 2 dias úteis (pois possui produtos de parceiros).
            </StyledParagraph>
            {discountAmount ? (
              <StyledParagraph>Frete grátis, pois completou a missão!</StyledParagraph>
            ) : (
              <StyledParagraph>
                {selectedMission
                  ? `Pedidos acima de R$${selectedMission} ganham frete grátis`
                  : 'Ative uma missão para ganhar frete grátis'}
              </StyledParagraph>
            )}
            <StyledAlert>
              Precisa receber antes? Por favor, remova os itens com etiqueta +2 dias.
            </StyledAlert>
          </div>
        </StyledType>
      </StyledToggleButton>
    </StyledToggleButtonGroup>
  )
}
